import { render, staticRenderFns } from "./SupportBtn.vue?vue&type=template&id=63bc44d4&scoped=true&"
import script from "./SupportBtn.vue?vue&type=script&lang=js&"
export * from "./SupportBtn.vue?vue&type=script&lang=js&"
import style0 from "./SupportBtn.vue?vue&type=style&index=0&id=63bc44d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bc44d4",
  null
  
)

export default component.exports